import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./features/auth/Login.jsx";
import Layout from "./layout/Layout";
import SignUp from "./features/auth/Signup.jsx";
import Dashboard from "./features/dashboard/pages/Dashboard.jsx";
import TourListings from "./features/tourPackage/pages/TourListings.jsx";
import TourPackageForm from "./features/tourPackage/form/TourPackageForm.jsx";
import ViewPackage from "./features/tourPackage/pages/ViewPackage.jsx";
import TourPackagePage from "./features/tourPackage/pages/TourPackagePage.jsx";
import DistributorPricingForm from "./features/pricing/components/DistributorPricingForm.jsx";
import ForgotPassword from "./features/auth/ForgotPassword.jsx";
import ResetPassword from "./features/auth/ResetPassword.jsx";
import TourBookingPage from "./features/bookings/pages/TourBookingPage.jsx";
import BookingsTable from "./features/bookings/components/BookingsTable.jsx";
import PaymentSuccess from "./features/payments/pages/PaymentSuccess.jsx";
import VerifyEmail from "./features/auth/VerifyEmail.jsx";
import LandingPage from "./features/landing/LandingPage.jsx";
import ProfilePage from "./features/profile/ProfilePage.jsx";
import DistributorPublicPage from "./features/distributor/DistributorPublicPage.jsx";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => !!(localStorage.getItem("authToken") || localStorage.getItem("token"))
  );

  return (
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        pauseOnHover
        draggable
      />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/login"
          element={<Login onLogin={() => setIsAuthenticated(true)} />}
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/verify-email" element={<VerifyEmail />} />

        <Route path="/book/:tourId" element={<TourBookingPage />} />
        <Route path="/d/:distributorId" element={<DistributorPublicPage />} />

        {isAuthenticated ? (
          <Route path="/" element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/tour-listings" element={<TourListings />} />
            <Route path="/manage-booking" element={<BookingsTable />} />
            <Route path="/tours" element={<TourPackagePage />} />
            <Route
              path="/pricing-rule-form"
              element={<DistributorPricingForm />}
            />
            <Route
              path="/edit-package/:id"
              element={<TourPackageForm mode="edit" />}
            />
            <Route path="/package/:id" element={<ViewPackage />} />
            <Route path="/create-package" element={<TourPackageForm />} />
            <Route path="/profile" element={<ProfilePage />} />
          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/" replace />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;
